let homeMenuList = [
  'KkrenIntroducSeq',
  'KkrenIntroducAir',
  'KkrenIntroducSe',
  'KkrenIntroducSea',
  'KkrenWarehouseShippingRates',
  'KkrenWarehouseAddress',
  // 'Charity',
  // 'PostListPtyt',
  'KkrenOrder',
  // 'KkrenParcelCanPack',
  'DgorderNavigation', // 個人版用代購
  'KkrenCommentList',
]

// 商務版默認菜單
let homeMenuListS = [
  'Dgorder',
  'KkrenIntroducAir',
  'KkrenIntroducSe',
  'KkrenCommentList',
  'KkrenWarehouseShippingRates',
  'KkrenWarehouseAddress',
  'KkrenOrder',
  'FinanceProof',
  'JyeInvoice',
]

if (!localStorage.newMenuList240103) {
  localStorage.removeItem('homeMenuList')
  localStorage.newMenuList240103 = '1'
}

if (localStorage.homeMenuList) {
  const str = localStorage.homeMenuList
  homeMenuList = JSON.parse(str)
}

if (localStorage.homeMenuListS) {
  const str = localStorage.homeMenuListS
  homeMenuListS = JSON.parse(str)
}

const state = {
  homeMenuList,
  homeMenuListS,
  showFzLogoDialog: false,
}

const getters = {
  homeMenuList: (state, getters, rootState) => {
    const homeMenuList = [...state.homeMenuList]

    if (!localStorage.homeMenuList) {
      if (rootState.userData.settings && rootState.edition === 's') {
      // 商务版的菜单
        return homeMenuListS
      } else if (homeMenuList.includes('DgorderNavigation')) {
        if (rootState.jyb.ordersubtno.seatwtosList.length) {
          homeMenuList.splice(homeMenuList.indexOf('DgorderNavigation'), 1, 'KkrenIntroducAssembleFurniture')
        } else {
          const hasTb = (rootState.userData.tpttPlatforms & 1) > 0
          const has1688 = (rootState.userData.tpttPlatforms & 2) > 0
          // TODO 改成有导入过淘宝的才显示，有绑定拼多多不显示
          // homeMenuList.splice(homeMenuList.indexOf('DgorderNavigation'), 1, 'TbdgFreeShipping')
          homeMenuList.splice(homeMenuList.indexOf('DgorderNavigation'), 1, 'Tbdg')
        // if (rootState.userData.hasJyorder <= 50) {
        //   homeMenuList.splice(homeMenuList.indexOf('DgorderNavigation'), 1, 'TbdgFreeShipping')
        // } else if (hasTb && has1688) {
        //   return homeMenuList
        // } else if (hasTb) {
        //   homeMenuList.splice(homeMenuList.indexOf('DgorderNavigation'), 1, 'Tbdg')
        // } else if (has1688) {
        //   homeMenuList.splice(homeMenuList.indexOf('DgorderNavigation'), 1, 'Dgorder')
        // }
        }
      }
    }

    return homeMenuList
  },
  homeMenuListS: (state) => {
    return state.homeMenuListS
  },
  coinMenuList: (state, getters, rootState, rootGetters) => {
    return [
      'Coin',
      'GamesWishingWall',
      'TpspTbkSearch',
      'TpspShakeCart',
      ...(rootGetters['splice/isAvailable'] ? ['Qiaoping'] : []),
      ...(rootGetters['splicegroup/isAvailable'] ? ['Splicegroup'] : []),
      'GamesBlindbox',
      'School',
    ]
  },
}

const mutations = {
  setHomeMenuList (state, v) {
    state.homeMenuList = v
    localStorage.homeMenuList = JSON.stringify(v)
  },
  setHomeMenuListS (state, v) {
    state.homeMenuListS = v
    localStorage.homeMenuListS = JSON.stringify(v)
  },
  setShowFzLogoDialog (state, v) {
    state.showFzLogoDialog = v
  },
}

const actions = {
  setHomeMenuList ({ state, commit, rootState }, v) {
    console.log('setHomeMenuList', v, rootState)
    if (rootState.edition === 's') {
      commit('setHomeMenuListS', v)
    } else {
      commit('setHomeMenuList', v)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
